/** Money is held as integer "micro" units (4 decimal places) while calculating, and as decimal strings at rest. */
export const MICRO = 10_000;

/** Parses "1.25", "1,25", "£1,234.50" or a number. Returns null for blanks and garbage. */
export function toMicro(value: string | number | null | undefined): number | null {
  if (value === null || value === undefined) return null;
  let n: number;
  if (typeof value === 'number') {
    n = value;
  } else {
    let s = value.trim().replace(/[£$€\s]/g, '');
    if (!s) return null;
    s = s.includes(',') && !s.includes('.') ? s.replace(',', '.') : s.replace(/,/g, '');
    if (!/^-?\d*\.?\d+$|^-?\d+\.$/.test(s)) return null;
    n = Number(s);
  }
  if (!Number.isFinite(n)) return null;
  return Math.round(n * MICRO);
}

export function microToDecimal(micro: number, places = 4): string {
  return (micro / MICRO).toFixed(places);
}

/** Normalises any accepted money input to a fixed-place decimal string, or null. */
export function toDecimal(value: string | number | null | undefined, places = 4): string | null {
  const micro = toMicro(value);
  return micro === null ? null : microToDecimal(micro, places);
}
